<script setup lang="ts">
import BaseTable, { DataTableHeader } from '../../base/table/BaseTable.vue'
import { useWalletState, WalletState, WalletTransaction } from '../../../utilities/account/useWallet'
import { formatCurrency, formatDate } from '../../../utilities/helpers'
import { getTransactionPaymentMethod, getTransactionTitle } from './useWalletTransactions'

import { i18n } from '../../../localization'
import CheckIcon from '../../base/icons/CheckIcon.vue'
import CrossIcon from '../../base/icons/CrossIcon.vue'
import WaitIcon from '../../base/icons/WaitIcon.vue'

defineProps<{
    transactions: WalletTransaction[]
}>()

const emit = defineEmits(['update:currentPage'])
const walletStore = useWalletState() as WalletState

const tableHeaders: DataTableHeader[] = [
    {
        text: i18n.global.t('wallet.transaction_date'),
        value: 'date',
        valueFormatter: formatDate,
    },
    {
        text: i18n.global.t('wallet.type'),
        value: 'wallet_type',
        itemFormatter: (value) =>
            String(value.wallet_type).slice(0, 1).toUpperCase() + String(value.wallet_type).slice(1),
    },
    {
        text: i18n.global.t('wallet.transaction_title'),
        value: 'transaction_title',
        itemFormatter: getTransactionTitle,
    },
    {
        text: i18n.global.t('wallet.transaction_payment_method'),
        value: 'method',
        itemFormatter: getTransactionPaymentMethod,
    },
    {
        text: i18n.global.t('wallet.transaction_amount'),
        value: 'signed_amount',
        classes: 'text-right',
    },
]

const handlePageChange = () => {
    emit('update:currentPage')
}
const getIconForTransaction = (transaction) => {
    if (transaction.status === 0) {
        return CheckIcon
    }
    if (transaction.status === 6 || transaction.status === 7) {
        return CrossIcon
    }
    return WaitIcon
}
</script>

<template>
    <BaseTable @update:currentPage="handlePageChange" :items="transactions" :headers="tableHeaders">
        <template #item.transaction_title="{ value }">
            <span class="text-gray-500">
                {{ value }}
            </span>
        </template>
        <template #item.signed_amount="{ item, value }">
            <span :class="[value < 0 ? 'text-red-600' : 'text-green-600', 'flex items-center space-x-2']">
                <p>{{ formatCurrency(value, 'EUR') }}</p>
                <Component :is="getIconForTransaction(item)" class="h-4 w-4" />
            </span>
        </template>
    </BaseTable>
</template>
